// Login Page
// Registration Page
// Basket Page
// Payment Information Page
// Payment Confirmation Page
// Delivery Information Page

function getIEVersion() {
    var agent = navigator.userAgent;
    var reg = /MSIE\s?(\d+)(?:\.(\d+))?/i;
    var matches = agent.match(reg);
    if (matches !== null) {
        return {
            major: matches[1],
            minor: matches[2]
        };
    }
    return {
        major: "-1",
        minor: "-1"
    };
}

var ie_version = getIEVersion();
var is_ie10 = ie_version.major > 9;

var WcsBrowser = {
    isChrome: navigator.userAgent.match(/chrome/i) !== null,
    isAndroid: navigator.userAgent.match(/android/i) !== null,
    isIpad: navigator.userAgent.match(/ipad/i) !== null,
    isIpadChrome: navigator.userAgent.match(/crios/i) !== null
};

window.rayban = window.rayban || {};





var _this = this;
/* Store this to avoid scope conflicts */

// local caching in case required, examples below

var $cached = {
    $checkbox: $('.wcs-icon-checkbox').next('input[type="checkbox"]'),
    forgot_password_form: $('form[name="forgot_password_form"]'),
    you_shopping_cart: $('.wcs-delivery-shopping-cart-accordian > h5.wcs-pos-relative'),
    shopping_toggle_items: $('.wcs-delivery-shopping-cart-accordian > div'),
    payment_mode_radio: $('#payment_mode input:radio'),
    payment_mode_payPal: $('#payment_mode_payPal'),
    payment_mode_creditCard: $('#payment_mode_creditCard'),
    payment_rayban_giftcard: $('.pay_with_giftCard'),
    gift_card_form: $('.gift_card_form'),
    add_gift_card: $('.add_gift_card'),
    applied_gift_card: $('.applied_gift_card'),
    delivery_information: $('#delivery_information'),
    info_button: $('.wcs-icon.wcs-info,.wcs-icon.wcs-card-verification-icon'),
    wcs_notification_box: $('.wcs-notification-box'),
    wcs_dropdown_validation: $('.wcs-dropdown-validation'),
    delivery_information_note_red: $(".delivery-information-note-red"),
    delivery_information_note_green: $(".delivery-information-note-green"),
    _self: ''
};

var getValue;
var getIntValue;
var getAttr;
var getId;
var zipCode;
var state;
var add_both_to_bag;
var add_quantity;
var scollInitiated = false;
var isFirstVisit = sessionStorage.getItem("FIRSTVISIT");
var startwith;

var _offset = null;
var getOffset = function(userAgent) {
    var _android = $('body').is('.android');

    if (_android && _offset === null) {

        if (userAgent.match(/GT-N8010/i) !== null) {
            _offset = 47;
        }
    }

    return _offset;
};